/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `* {
  box-sizing: border-box;
}

:host {
  font-size: 1rem;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-content: flex-start;
  align-items: flex-start;
}
:host .status {
  order: 0;
  flex: 0 0 auto;
  align-self: center;
  height: calc(24rem/14);
  width: calc(24rem/14);
}
:host .status davinci-icon,
:host .status davinci-icon-ref,
:host .status davinci-spinner {
  font-size: 1rem;
}
:host .text {
  flex: 1 1 auto;
  margin-top: calc(1rem/14);
  margin-right: calc(3rem/14);
  margin-left: calc(3rem/14);
  font-size: inherit;
  line-height: calc(22rem/14);
  color: #2C3133;
  color: var(--davinci-color-text, #2C3133);
}

:host([value=success]) .status > davinci-icon {
  fill: #63b017;
  fill: var(--davinci-color-success, #63b017);
}

:host([value=error]) .status > davinci-icon {
  fill: #EA0823;
  fill: var(--davinci-color-error, #EA0823);
}

:host([hidden]) {
  display: none;
}`;
export { style };
